import styled from 'styled-components';

export const HomePageStyled = styled.div`
  .specialtyContainer {
    padding: 0 50px;
  }

  .eHome {
    margin-top: 0;
  }

  @media (max-width: 820px) {
    .pageContent {
      padding-top: ${(props) => (props?.isNotSafari ? '220px' : '175px')};
    }
  }

  @media (max-width: 480px) {
    .pageContent {
      padding-top: ${(props) => (props?.isNotSafari ? '190px' : '130px')};
    }
  }

  @media (max-width: 380px) {
    .pageContent {
      padding-top: ${(props) => (props?.isNotSafari ? '170px' : '120px')};
    }
  }
`;
